function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7_399)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.1697 0.438354H6.43461C6.34372 0.430901 6.25257 0.426992 6.16138 0.426636C4.24822 0.426636 2.69727 1.97754 2.69727 3.8907C2.69727 3.98379 2.70102 4.07595 2.70823 4.16717H2.69727V22.3545C2.69727 23.2713 3.44047 24.0146 4.3573 24.0146H6.26197V20.2092C6.42781 20.2601 6.6003 20.2858 6.77375 20.2857H20.7267C21.6897 20.2857 22.4704 19.505 22.4704 18.542V2.73898C22.4704 1.46839 21.4403 0.438354 20.1697 0.438354Z",
  fill: "#C49270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.482 3.43387C21.482 2.40299 20.5093 1.56018 19.2807 1.49624V1.49188H6.16123C5.20465 1.49188 4.4292 2.08569 4.4292 2.81816C4.4292 3.55063 5.20465 4.14444 6.16123 4.14444V4.16718H15.6676V22.494L19.1308 22.9005C20.4758 22.9005 21.482 20.2392 21.482 18.9249V3.52621H21.4792C21.4809 3.4956 21.482 3.46485 21.482 3.43387Z",
  fill: "#DCE2E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4187 4.16724H6.26196V24.0146H18.4187C19.368 24.0146 20.1376 23.245 20.1376 22.2957V5.8861C20.1376 4.93678 19.368 4.16724 18.4187 4.16724Z",
  fill: "#EDC0A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7427 11.5177H9.51094C9.13814 11.5177 8.83594 11.2155 8.83594 10.8427V8.49354C8.83594 8.12075 9.13814 7.81854 9.51094 7.81854H15.7427C16.1155 7.81854 16.4177 8.12075 16.4177 8.49354V10.8427C16.4177 11.2155 16.1155 11.5177 15.7427 11.5177Z",
  fill: "#F9F9F7"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7_399"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.110352 0.248962)"
})));

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.066fe4ded359ab521b826a5f28f3a3b7.svg";
export { ForwardRef as ReactComponent };